import React from 'react';
import { FormControl, Typography } from '@mui/material';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import './CustomePhoneTextField.css';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { ThemeContext } from '../../module/ThemeManager';
import whatsapp from '../../asset/images/icons/whatapp.svg';
import whatsapp_black from '../../asset/images/icons/whatapp_black.svg';
import { useSelector } from 'react-redux';
import { userLocationSelector } from '../MapModal/selector';

export interface ICustomPhoneTextFieldProps {
    onChange?: (e: any, data: CountryData) => void;
    onBlur?: (e: any) => void;
    value?: string;
    isErrorState?: boolean;
    errorMsg?: string;
    instruction?: string;
    onFocus?: () => void;
    isFocused?: boolean;
    customStyle?: React.CSSProperties;
    label?: string;
}

export const CustomPhoneTextField: React.FC<ICustomPhoneTextFieldProps> = ({
    onChange,
    value,
    onBlur,
    isErrorState,
    errorMsg,
    instruction,
    onFocus,
    isFocused,
    customStyle,
    label,
}) => {
    const location = useSelector(userLocationSelector);

    return (
        <ThemeContext.Consumer>
            {({ themeStyle }) => {
                const colorScheme = themeStyle as ColorScheme;

                const datalistStyle: React.CSSProperties = {
                    width: '100%',
                    paddingRight: 10,
                    backgroundColor: theme[colorScheme].form_gray,
                    border: `1px solid ${
                        isErrorState && !isFocused
                            ? theme[colorScheme].secondary_red
                            : theme[colorScheme].placeholderGray50
                    }`,
                    borderRadius: 8,
                    fontFamily: FONT_ENUM.MAIN_REGULAR,
                    fontSize: 14,
                    color: theme[colorScheme].lightWhite,
                    backgroundImage: `url(${colorScheme === 'dark' ? whatsapp : whatsapp_black})`,
                    backgroundSize: '20px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    backgroundOrigin: 'content-box',
                    ...customStyle,
                };

                const dropdownStyle: React.CSSProperties = {
                    backgroundColor: theme[colorScheme].form_gray,
                    color: theme[colorScheme].lightWhite,
                    width: '400px',
                };

                const errorMsgStyle: React.CSSProperties = {
                    color: theme[colorScheme].secondary_red,
                    fontFamily: FONT_ENUM.MEDIUM_TEXT,
                    fontSize: 12,
                    marginTop: 5,
                };

                const instructionStyle: React.CSSProperties = {
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 12,
                    fontStyle: 'normal',
                    fontWeight: 400,
                    color: theme[colorScheme].form_label,
                    fontFamily: FONT_ENUM.MAIN_REGULAR,
                    marginTop: 5,
                };

                return (
                    <FormControl sx={{ width: '100%' }}>
                        {!!label && (
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 2.5,
                                    fontFamily: FONT_ENUM.MAIN_REGULAR,
                                    color: theme[colorScheme].form_label,
                                }}>
                                {label}
                            </Typography>
                        )}

                        <PhoneInput
                            onChange={onChange}
                            value={value}
                            country={location?.country_code?.toLowerCase() || 'us'}
                            specialLabel=""
                            inputStyle={datalistStyle}
                            dropdownStyle={dropdownStyle}
                            onBlur={onBlur}
                            onFocus={onFocus}
                            countryCodeEditable={false}
                        />

                        {isErrorState && !!errorMsg && !isFocused && (
                            <Typography style={errorMsgStyle}>{errorMsg}</Typography>
                        )}

                        {!!instruction && isFocused && <Typography style={instructionStyle}>{instruction}</Typography>}
                    </FormControl>
                );
            }}
        </ThemeContext.Consumer>
    );
};
